import { AuthProvider, useAuth } from "@/hooks/use-auth.tsx";
import { LoadingBarProvider } from "@/hooks/use-loading-bar.tsx";
import { ThemeProvider } from "@/hooks/use-theme.tsx";
import { queryClient } from "@/query-client.ts";
import { routeTree } from "@/route-tree.gen.ts";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

const router = createRouter({
  routeTree,
  context: {
    queryClient,
    auth: undefined!,
  },
  defaultPreload: false,
  defaultPreloadStaleTime: 0,
  // globalNotFound: <GlobalNotFound />,
  // defaultErrorComponent: ({ error }) => <PageForbidden />,
  // defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
  // notFoundComponent: () => <PageForbidden />,
});

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

function Router() {
  const auth = useAuth();

  return <LoadingBarProvider>{!auth.isLoading ? <RouterProvider router={router} context={{ auth }} /> : null}</LoadingBarProvider>;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <AuthProvider>
          <Router />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

const rootElement = document.getElementById("app")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
